import { Archive, FileText, House, ShieldCheck, UserRound, type LucideIcon } from "lucide-react";

/** The five shell destinations (Account is the hub for the rest). */
export const DESTINATIONS: { to: string; labelKey: string; icon: LucideIcon; end?: boolean }[] = [
  { to: "/", labelKey: "nav.home", icon: House, end: true },
  { to: "/vault", labelKey: "nav.vault", icon: Archive },
  { to: "/policies", labelKey: "nav.policies", icon: ShieldCheck },
  { to: "/claims", labelKey: "nav.claims", icon: FileText },
  { to: "/account", labelKey: "nav.account", icon: UserRound },
];
